"use client"

import { Translate } from "@/components/translate"
import { Img } from "@/components/ui/image"

const ChatIn = () => {
  const openChat = () => {
    window.vivochaEngageChat?.()
  }

  return (
    <div className="mb-6 flex w-full flex-wrap items-center gap-4 px-3 md:basis-1/2">
      <div
        className="contactIcon flex size-16 cursor-pointer items-center justify-center rounded-full bg-btn-primary md:size-20"
        onClick={openChat}
      >
        <Img
          alt="livechat"
          src="/assets/error-page/chat.svg"
          width={1}
          height={1}
          className="size-10 md:size-16"
        />
      </div>
      <div
        className="contact-caption callInfo cursor-pointer font-primary font-bold"
        onClick={openChat}
      >
        <span className="contactTitle text-paragraph-s">
          <Translate i18nKey="ErrorPage.writeIn" />
        </span>
        <br />
        <span className="contact-content text-title-xl">
          <u>
            <Translate i18nKey="ErrorPage.liveChat" />
          </u>
        </span>
      </div>
    </div>
  )
}

export { ChatIn }
